module.exports = __webpack_public_path__ + "img/Cloud Architect.59a5c63f.png";